const PREFIX_APP = "CAPCO_AFFILIATE_";

export const LOCAL_STORAGE_KEY = {
  ACCESS_TOKEN: PREFIX_APP + "ACCESS_TOKEN"
};

export const KATAKANA_ONLY_REGEX = /[^ァ-ヶー\s]/g;
